import { useMemo } from "react";

import { useLocalStorage } from "usehooks-ts";

import { createFNVHashSync } from "../../authentication/utils";
import { useCurrentUser } from "../../contexts/CurrentUserContext";

import type { ChartType, TimePeriod } from "./types";

export type BalanceChartPreferenceState = {
  timePeriod: TimePeriod;
  chartType: ChartType | null;
  includeHiddenAccounts: boolean;
};

export const DEFAULT_BALANCE_CHART_PREFERENCE_STATE: BalanceChartPreferenceState =
  {
    timePeriod: "quarter",
    chartType: null,
    includeHiddenAccounts: false,
  };

export const getBalanceChartStorageKey = (userId: string): string => {
  const hashedId = createFNVHashSync(userId);
  return `balance_chart_${hashedId}`;
};

export const useBalanceChartStorage = (userId: string) => {
  const storageKey = useMemo(() => getBalanceChartStorageKey(userId), [userId]);

  const [state, setState, removeValue] =
    useLocalStorage<BalanceChartPreferenceState>(
      storageKey,
      DEFAULT_BALANCE_CHART_PREFERENCE_STATE
    );

  return [state, setState, removeValue] as const;
};

export const useCurrentUserBalanceChartStorage = () => {
  const { currentUser } = useCurrentUser();
  const userId = currentUser?.id?.toString() || "";

  return useBalanceChartStorage(userId);
};
